var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointingArrow = function SvgPointingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.758 10 25.547 20v-5.014l-18.35-3.56v-.022L0 10l7.198-1.405v-.022l18.349-3.56V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pointing-arrow_svg__a)",
    d: "M39.865 10 27 2.525v3.687L7.475 10 27 13.788v3.687z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pointing-arrow_svg__a",
    x1: 7.475,
    x2: 39.865,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15803D"
  })))));
};
export default SvgPointingArrow;